/* eslint-disable no-undef */
export const parserData = (form) => {
  const formData = new FormData();
  formData.append('nombre', form.nombre);
  formData.append('planta', form.planta);
  formData.append('descripcion', form.descripcion);
  formData.append('imagen', form.imagen);
  return formData;
};
